// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getUser, getUI } from 'redux/selectors';
import * as JournalActions from 'redux/actions/journal';
import * as EntryActions from 'redux/actions/entry';
import { updateUI } from 'redux/actions/ui';
import OutsideClickHandler from 'react-outside-click-handler/esm/OutsideClickHandler';

import iconTag from 'assets/images/icons_svg/icon_tag.svg';

const ChapterDropdownList = ({
    dispatch,
    ui,
    entry,
    journalId,
    onUpdate,
    shouldRenderTagsName
}) => {
    const [chapters, setChapters] = useState([]);
    const [selectedChapters, setSelectedChapters] = useState([]);
    const [showList, setShowList] = useState(false);

    const [hasFetched, setHasFetched] = useState(false);

    // Initialize selectedChapters from the embedded chapter objects inside the entry
    useEffect(() => {
        if (Array.isArray(entry?.chapters)) {
            const preSelected = entry.chapters
                .map((c) => {
                    if (typeof c === 'object' && c) {
                        return {
                            id: c.id,
                            name: c.chapter_name || c.name,
                            start_date: c.start_date,
                            end_date: c.end_date,
                            resource_uri: c.resource_uri || `chapters/${c.id}/`
                        };
                    }
                    return null;
                })
                .filter(Boolean);
            if (preSelected.length > 0 && selectedChapters.length === 0) {
                setSelectedChapters(preSelected);
            }
        }
        // eslint-disable-next-line
    }, [entry?.chapters]);

    const renderSelectedName = () => {
        if (!selectedChapters || selectedChapters.length === 0) {
            return null;
        }
        let name = selectedChapters[0]?.name || '';
        if (selectedChapters[1]?.name) {
            name += `, ${selectedChapters[1].name}`;
        }
        return name || null;
    };

    const renderBadge = () => {
        if (selectedChapters && selectedChapters.length > 2) {
            return `+${selectedChapters.length - 2}`;
        }
        return null;
    };

    const onSelect = (chapter) => {
        const alreadySelected = selectedChapters.find(
            (c) => c.id === chapter.id
        );
        const updated = alreadySelected
            ? selectedChapters.filter((c) => c.id !== chapter.id)
            : [...selectedChapters, chapter];
        setSelectedChapters(updated);
    };

    const onCommit = () => {
        setShowList(false);
        const mappedChapterIds = selectedChapters.map((c) =>
            typeof c === 'object' ? c.id : c
        );

        // Store chapters in Redux UI state (mirrors how tags store to ui.newEntry.tags)
        dispatch(
            updateUI(
                {
                    newEntry: {
                        chapters: mappedChapterIds
                    }
                },
                false
            )
        );

        // Notify parent (e.g. to trigger hasChanged / onChange signaling)
        if (onUpdate) {
            onUpdate(selectedChapters);
        }

        // For existing entries, also directly save via API (same as TagDropdownList)
        if (entry?.id) {
            dispatch(
                EntryActions.update({ chapters: mappedChapterIds }, entry.id)
            );
        }
    };

    const toggle = () => {
        if (showList) {
            onCommit();
        } else {
            setShowList(true);
            if (!hasFetched && journalId) {
                dispatch(JournalActions.fetchChapters(journalId)).then(
                    (res) => {
                        const results = res?.payload?.data?.results || [];
                        const fetchedChapters = results.map((ch) => ({
                            id: ch.id,
                            name: ch.chapter_name,
                            start_date: ch.start_date,
                            end_date: ch.end_date,
                            resource_uri: `chapters/${ch.id}/`
                        }));
                        setChapters(fetchedChapters);
                        setHasFetched(true);
                    }
                );
            }
        }
    };

    return (
        <div className="post-tags ml-auto">
            {shouldRenderTagsName && renderSelectedName() && (
                <span className="tags-used">{renderSelectedName()}</span>
            )}
            {renderBadge() && (
                <span className="tags-badge">{renderBadge()}</span>
            )}
            <OutsideClickHandler
                onOutsideClick={() => {
                    if (showList) {
                        onCommit();
                    }
                }}>
                <div className="dropdown show">
                    <button
                        className={`btn-icon btn-icon--4 post-tags__button ${
                            selectedChapters.length > 0 ? 'btn-xp' : ''
                        }`}
                        onClick={toggle}>
                        <img src={iconTag} alt="Chapters" />
                    </button>
                    <div
                        className={`dropdown-menu tags-dropdown-menu ${
                            showList ? 'show' : ''
                        }`}>
                        {chapters.length === 0 ? (
                            <div
                                style={{
                                    padding: '10px 14px',
                                    fontSize: '13px',
                                    color: '#999'
                                }}>
                                No chapters yet. Add chapters in Journal
                                Settings.
                            </div>
                        ) : (
                            <ul className="dropdown-tags-list">
                                {chapters.map((ch) => {
                                    const isSelected = !!selectedChapters.find(
                                        (c) => c.id === ch.id
                                    );
                                    return (
                                        <li
                                            key={ch.id}
                                            className={
                                                isSelected
                                                    ? 'active-item-list'
                                                    : ''
                                            }
                                            onClick={() => onSelect(ch)}>
                                            <img src={iconTag} alt="" />
                                            <span>{ch.name}</span>
                                            {ch.merged_from_display_name && (
                                                <span
                                                    style={{
                                                        fontSize: '11px',
                                                        color: '#6b6b6b',
                                                        marginLeft: '6px'
                                                    }}>
                                                    Merged from:{' '}
                                                    {
                                                        ch.merged_from_display_name
                                                    }
                                                </span>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>
                </div>
            </OutsideClickHandler>
        </div>
    );
};

const state = createStructuredSelector({
    user: getUser,
    ui: getUI
});

export default connect(state)(ChapterDropdownList);
